module.exports = __webpack_public_path__ + "static/assets/7f41449e898401168112236180fcf9d6.svg";